module.exports = "https://static.wanderu.com/static/media/logo.79064255.png";